import {useMemo} from 'react'
import {useTable, ColumnInstance, Row} from 'react-table'
import {CustomHeaderColumn} from './columns/CustomHeaderColumn'
import {CustomRow} from './columns/CustomRow'
import {
  useQueryResponseData,
  useQueryResponseLoading,
  // useQueryResponsePagination,
} from '../core/QueryResponseProvider'
import {blockUsersColumns} from './columns/_columns'
import {BlockUser} from '../core/_models'
import {KTCardBody} from '../../../../../../_metronic/helpers'
import {EventsListSearchComponent} from '../components/EventsListSearchComponent'
import EventAdd from './columns/BlockAdd'
import {UsersListLoading} from '../../users-list/components/loading/UserListLoading'
import { BlockUserListPagination } from '../components/pagination/BlockUserListpagination'

const BlockTable = () => {
  const events = useQueryResponseData()
  const isLoading = useQueryResponseLoading()
  // const pagination = useQueryResponsePagination()

  const data = useMemo(() => events, [events])
  const columns = useMemo(() => blockUsersColumns, [])
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })

  return (
    <KTCardBody className='pt-8 pb-4'>
      <div className='mb-7 mt-0 d-flex align-items-center'>
        <div>
          <EventsListSearchComponent placeholder='Search Block Users' />
        </div>
        <div className='ms-auto'>
          <EventAdd />
        </div>
      </div>
      <div className='table-responsive'>
        <table
          id='kt_table_events'
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-gray-800 fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map((column: ColumnInstance<BlockUser>) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<BlockUser>, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={10}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    No matching records found
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <BlockUserListPagination />
      {isLoading && <UsersListLoading />}
    </KTCardBody>
  )
}

export {BlockTable}
